var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop-video"},[(_vm.item.video)?_c('basis-video-player',{staticClass:"video-player",attrs:{"item":_vm.item,"cover-options":{
      aspectRatio: '1:1',
      controlBar: {
        timeDivider: true,
        durationDisplay: true,
        remainingTimeDisplay: false,
        fullscreenToggle: true //全屏按钮
      }
    }},on:{"playerReadied":_vm.onPlayerReadied},model:{value:(_vm.videoPlayer),callback:function ($$v) {_vm.videoPlayer=$$v},expression:"videoPlayer"}}):_vm._e(),(!_vm.item.video)?_c('div',{class:['not-video', {'is-locked': _vm.item.locked}],style:({backgroundImage:("url(" + (_vm.item.cover) + ")")})}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }